import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ClipboardList } from "lucide-react";

export default function AuditLogsPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs?limit=200").then((r) => setLogs(r.data.items || [])); }, []);
  return (
    <div className="space-y-5" data-testid="audit-logs-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#d4a574] mb-2 font-semibold">Audit Logs</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">System Activity</h1>
      </div>
      <div className="border border-[#33291f] rounded-lg bg-[#1c1712] overflow-hidden">
        <table className="w-full text-[13px]">
          <thead className="bg-[#241d16] text-[10px] uppercase tracking-wider text-[#7a6d5a]">
            <tr>
              <th className="text-left px-4 py-2">Time</th>
              <th className="text-left px-4 py-2">User</th>
              <th className="text-left px-4 py-2">Action</th>
              <th className="text-left px-4 py-2">Target</th>
              <th className="text-left px-4 py-2">Meta</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-[#33291f]" data-testid={`audit-row-${l.id}`}>
                <td className="px-4 py-2 font-mono text-[11px] text-[#7a6d5a]">{l.created_at?.slice(0, 19).replace("T", " ")}</td>
                <td className="px-4 py-2 font-mono text-[11px] text-[#b8ac96]">{l.user_id?.slice(0, 8) || "system"}</td>
                <td className="px-4 py-2"><span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded bg-[#241d16] text-[#d4a574] border border-[#4a3a2b] font-mono">{l.action}</span></td>
                <td className="px-4 py-2 text-[11px] text-[#b8ac96]">{l.target_type ? `${l.target_type}:${l.target_id?.slice(0, 8)}` : "—"}</td>
                <td className="px-4 py-2 font-mono text-[10px] text-[#7a6d5a] max-w-md truncate">{Object.keys(l.meta || {}).length ? JSON.stringify(l.meta) : "—"}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-[#7a6d5a]">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
